<template>
    <div class="container-fluid w-100" style="overflow: hidden">
        <navbar :title="$t('observations.group_title')"/>
        <div class="col-sm-12 nopads my-2">
            <observation-group-list
              :results="results"
              @add="addObservationGroup"
              @edit="editObservationGroup"
            />
        </div>
        <base-modal v-if="editMode" hide-header hide-footer @close="editMode = false">
            <observation-group-editor
              :observation-group="observationGroup"
              @close="showObservationGroupList"
              @close-and-update="closeAndUpdate"
            />
        </base-modal>
    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
  </div>
</template>

<script>
import {restApi} from '../../mixins/RestApiMixin'
import {observationHelper} from '../../mixins/ObservationMixin'
import ObservationGroupList from './ObservationGroupList'
import ObservationGroupEditor from './ObservationGroupEditor'
import Navbar from "@/components/utils/Navbar";
import BaseModal from "@/components/BaseModal";

export default {
    name: 'ObservationGroups',
    components: {BaseModal, Navbar, ObservationGroupList, ObservationGroupEditor},
    mixins: [restApi, observationHelper],
    data: function () {
        return {
            results: [],
            observationGroup: null,
            editMode: false,
            loading: false
        }
    },
    mounted: function () {
        this.fetchObservationGroups()
    },
    methods: {
        fetchObservationGroups: function () {
            this.loading = true
            this.restFetch(this.observationGroupUrl, this.handleResponse)
        },
        handleResponse: function (response) {
            this.results = response.data
            this.loading = false
        },
        searchWithCompany: function (companyId) {
            this.results = []
            if (companyId) {
                this.loading = true
                this.restFetchParams(this.observationGroupUrl, {company: companyId}, this.handleResponse)
            }
        },
        addObservationGroup: function () {
            this.observationGroup = this.newObservationGroup()
            this.editMode = true
        },
        editObservationGroup: function (group) {
            this.observationGroup = group
            this.editMode = true
        },
        showObservationGroupList: function () {
            this.editMode = false
        },
        closeAndUpdate: function () {
            this.fetchObservationGroups()
            this.showObservationGroupList()
        }
    }
}
</script>
